import { PageRoute } from "../../routes/PageRoute";
import { Language } from "../Languages/Languages";

export interface MenuContent {
  Type: "Route" | "Language" | "Link";
  Name?: string;
  Route?: PageRoute;
  Languages?: Language[];
  Link?: string;

  SubMenu?: MenuContent[];
}

const homeRoute: PageRoute = { Name: "Home", Route: "/", IsMainRoute: true };
const bioRoute: PageRoute = { Name: "Bio", Route: "/bio", IsMainRoute: true };
const serviziRoute: PageRoute = {
  Name: "Servizi",
  Route: "/servizi",
  IsMainRoute: true,
};
const contattiRoute: PageRoute = {
  Name: "Contatti",
  Route: "/contatti",
  IsMainRoute: true,
};
const fakeRoute: PageRoute = {
  Name: "Fake",
  Route: "/fake",
  IsMainRoute: true,
}
const sampleRoute: PageRoute = {
  Name: "Sample",
  Route: "/sample",
  IsMainRoute: true,
}

const languages: Language[] = [
  { Name: "Italiano", Value: "it" },
  { Name: "English", Value: "en" },
];

export const newsSubMenuItems: MenuContent[] = [
  { Type: "Route", Route: fakeRoute },
  // { Type: "Route", Route: bioRoute },
  // { Type: "Route", Route: contattiRoute },
  // { Type: "Route", Route: serviziRoute },
];

export const sampleSubMenuItems: MenuContent[] = [
  { Type: "Route", Route: sampleRoute },
  // { Type: "Route", Route: bioRoute },
  // { Type: "Route", Route: contattiRoute },
  // { Type: "Route", Route: serviziRoute },
];

export const menuItems: MenuContent[] = [
  { Type: "Route", Route: homeRoute },
  { Type: "Route", Route: bioRoute },
  { Type: "Route", Route: serviziRoute },
  // { Type: "Route", SubMenu: sampleSubMenuItems, Name: "Sample" },
  // { Type: "Route", SubMenu: newsSubMenuItems, Name: "News" },
  { Type: "Language", Languages: languages, Name: "Language" },
  { Type: "Route", Route: contattiRoute },
];
